import { render, staticRenderFns } from "./KycDetailsTableCell.vue?vue&type=template&id=1447d31e&scoped=true&"
import script from "./KycDetailsTableCell.vue?vue&type=script&lang=js&"
export * from "./KycDetailsTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447d31e",
  null
  
)

export default component.exports